import styled from '@emotion/styled';
import React from 'react';
import { mergeProps, useFocusRing } from 'react-aria';

import { Glyph } from '../common/Glyph';
import { useTabContext } from '../tabs/Tab';

import { su } from '../../theme/functions/su';
import { motion } from '../../theme/motion';
import { theme } from '../../theme/theme';

import { getControlComponentGlyph } from './getControlComponentGlyph';

export function ControlsComponentTab(props) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars -- intentionally unused
  const { ref, tab, item, value, state } = useTabContext();
  const focusRing = useFocusRing();

  const isSelected = state.selectedKey === item.key;
  const isDisabled = state.disabledKeys.has(item.key);
  const isFocused = state.selectionManager.focusedKey === item.key;
  const glyphSource = getControlComponentGlyph(item.key);

  return (
    <ControlsComponentTab.Root
      {...mergeProps(tab.tabProps, focusRing.focusProps)}
      ref={ref}
      data-is-selected={isSelected}
      data-is-disabled={isDisabled}
      data-is-focused={isFocused}
      data-is-focus-visible={focusRing.isFocusVisible}
    >
      {glyphSource != null && (
        <Glyph source={glyphSource} size={theme.icon.size_xlarge} color={theme.color.white} />
      )}
    </ControlsComponentTab.Root>
  );
}

ControlsComponentTab.Root = styled.div`
  padding: ${su(1)};
  opacity: 0.5;
  outline: 0;
  border-radius: ${theme.borderRadius.small};
  transition: ${motion.duration.micro} ${motion.curve.ease_in_out};
  transition-property: transform, opacity;
  cursor: pointer;

  &[data-is-selected='true'] {
    opacity: 1;
  }

  &[data-is-disabled='true'] {
    opacity: 0.25;
  }

  &[data-is-focus-visible='true'] {
    outline: 2px solid ${theme.color.highlight};
    outline-offset: 2px;
  }

  &:hover {
    opacity: 1;
  }

  &:active {
    opacity: 1;
    transform: scale(0.97);
  }
`;
